
import Alert, { AlertRoot } from "./AlertCrossPlatform";

export default Alert
export { AlertRoot }